import {Pipe, PipeTransform} from '@angular/core';
import {Request} from '../../classes/request';
import {
    CUP_PROBLEM_LABEL,
    hasCupProblem,
    hasParticipationProblem,
    hasStampProblem,
    PARTICIPATION_PROBLEM_LABEL,
    practiceFolderName,
    practicePhaseLabel,
    STAMP_PROBLEM_LABEL
} from '../../utils/dnsProblems';

@Pipe({
    name: 'dnsProblemFilter',
    pure: false
})
export class DnsProblemFilterPipe implements PipeTransform {

    transform(requestList: Array<Request>,
              activeView: string,
              stampFilterValues: string[],
              cupFilterValues: string[],
              practicePhaseFilterValues: string[],
              notesFilterValue: string,
              folderNameFilterValue: string): any {
        if (!requestList || activeView !== 'dns') {
            return requestList;
        }

        const stamp = stampFilterValues || [];
        const cup = cupFilterValues || [];
        const phase = practicePhaseFilterValues || [];
        const notes = (notesFilterValue || '').trim().toLowerCase();
        const folder = (folderNameFilterValue || '').trim().toLowerCase();
        if (!stamp.length && !cup.length && !phase.length && !notes && !folder) {
            return requestList;
        }

        const filterStamp = stamp.includes(STAMP_PROBLEM_LABEL);
        const filterParticipation = stamp.includes(PARTICIPATION_PROBLEM_LABEL);
        const filterCup = cup.includes(CUP_PROBLEM_LABEL);

        return requestList.filter(request => {
            if (filterStamp && !hasStampProblem(request)) {
                return false;
            }
            if (filterParticipation && !hasParticipationProblem(request)) {
                return false;
            }
            if (filterCup && !hasCupProblem(request)) {
                return false;
            }
            if (phase.length && !phase.includes(practicePhaseLabel(request))) {
                return false;
            }
            if (notes && (request.Notes || '').toLowerCase().indexOf(notes) === -1) {
                return false;
            }
            return !folder || practiceFolderName(request).toLowerCase().indexOf(folder) !== -1;
        });
    }

}
